import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Layout from "./components/layout";
import UploadMedia from "./pages/UploadMedia";
import Blog from "./pages/blog"
import SingleWorkOut from "./pages/SingleWorkOut";
import WorkoutPlans from "./pages/WorkoutPlans";
import LandingCard from "./pages/LandingCard";
import AddNewRecipe from "./pages/AddNewRecipie";
import Challenge from "./pages/Challenge";
import RecipeMotivationalManager from "./pages/RecipieMotivationalManager";
import { ToastContainer } from "react-toastify";
// import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

import ProtectedRoute from "./components/ProtectedRoute";
import UpdateAllWorkoutTag from "./pages/UpdateAllWorkoutTag";
import UserProfilesList from "./pages/UserProfilesList";
import UserDetails from "./pages/UserDetails";
import Notification from "./pages/Notification";

const App = () => {
  const location = useLocation();
  const noLayoutRoutes = ["/", "/user-detail/:userId"];

  return (
    <>
      {!noLayoutRoutes.includes(location.pathname) && <Layout />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={Dashboard} />}
        />
        <Route
          path="/upload-media"
          element={<ProtectedRoute element={UploadMedia} />}
        />
        <Route
          path="/workout-plans"
          element={<ProtectedRoute element={WorkoutPlans} />}
        />
        <Route
          path="/single-workout"
          element={<ProtectedRoute element={SingleWorkOut} />}
        />
        <Route
          path="/add-new-recipe"
          element={<ProtectedRoute element={AddNewRecipe} />}
        />
        <Route
          path="/chalanges"
          element={<ProtectedRoute element={Challenge} />}
        />
        <Route
          path="/notification"
          element={<ProtectedRoute element={Notification} />}
        />
        
        <Route
          path="/add-recipe-motivation"
          element={<ProtectedRoute element={RecipeMotivationalManager} />}
        />
        <Route
          path="/update-workout-tag"
          element={<ProtectedRoute element={UpdateAllWorkoutTag} />}
        />
        <Route
          path="/users"
          element={<ProtectedRoute element={UserProfilesList} />}
        />
        <Route
          path="/user-detail/:userId"
          element={<ProtectedRoute element={UserDetails} />}
        />
        <Route
          path="/blog"
          element={<ProtectedRoute element={Blog} />}
        />
         <Route
          path="/landing"
          element={<ProtectedRoute element={LandingCard} />}
        />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
